import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  filtersContainer: {
    width: "100%",
    paddingTop: "20px",
    paddingLeft: "16px",
    paddingRight: "18.5px",
    color: "#fff",
    position: "relative",
    height: "100%",
  },
  title: {
    fontWeight: "bold",
  },
  subtitle: {
    fontWeight: "bold",
    // marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      // marginTop: theme.spacing(2),
    },
  },
  inputBackgroundColor: {
    backgroundColor: "#fff",
    "&.Mui-focused": {
      background: "white",
    },
    "&:hover": {
      background: "white",
    },
  },
  formControl: {
    height: "32px",
    width: "100%",
  },
  sliderColor: {
    color: "#fff",
    marginTop: theme.spacing(3),
    marginLeft: 8,
    width: "calc(100% - 16px)",
  },
  buttonColor: {
    color: "#fff",
  },
  clearButton: {
    textAlign: "center",
    paddingTop: 10,
    paddingBottom: 10,
    [theme.breakpoints.down("md")]: {
      // marginBottom: "-10px",
      bottom: 0,
      position: "relative",
      paddingBottom: 0,
    },
  },
  select: {
    height: "100%",
    backgroundColor: "#0929582B",
    borderRadius: "4px",
  },
  selectRoot: {
    "&:focus": {
      backgroundColor: "rgb(0,0,0,0)",
    },
  },
  icon: {
    color: "#fff",
  },
}))

export default styles
